<div id="scanshare" class="loader_scan">
  <ng-container class="loader_processing" *ngIf="processing">
    <img src="assets/images/3-dots-scale.svg" alt="spinner" width="100" height="100">
    <app-paragraph class="mt_20" textAlign="center">{{'scan_share.processing' | translate}}</app-paragraph>
  </ng-container>
</div>
